/**
 * Views navigate through this module rather than holding a reference to the router, which keeps
 * them free of wiring and trivially testable.
 */

import type { Router } from './router';

let router: Router | null = null;

export function attachRouter(instance: Router): void {
  router = instance;
}

export function navigate(path: string, options: { replace?: boolean } = {}): void {
  if (!router) {
    window.location.assign(path);
    return;
  }
  router.go(path, options);
}
